import { QUIZ_CONSTANTS } from '~/actions/quiz/constants';
import { getFromLocalStorage, saveToLocalStorage } from '~/helpers/storage';

/**
 * Проверяет наличие записи в localStorage 
 * @param quizId 
 * @returns 
 */
export const hasQuizInLocalStorage = (quizId: string): boolean => {
  return getFromLocalStorage(QUIZ_CONSTANTS.KEY_SHOWN_QUIZZES, quizId)
    ? true
    : false;
};

/**
 * Создает запись о квизе в localStorage
 * @param quizId 
 */
export const saveEventShowQuizToLocalStorage = (quizId: string) => {
  saveToLocalStorage(QUIZ_CONSTANTS.KEY_SHOWN_QUIZZES, quizId, {
    time: Date.now(),
    uuid: quizId,
    href: document.location.href,
  });
};